import './polyfills';

import React from 'react';

import ReactDOM from 'react-dom';

import * as serviceWorker from '@ttstr/components/ServiceWorker/ServiceWorker';

import { injectGoogle, injectMetaPixels, injectTikTokPixels } from '@ttstr/utils';

import App from './App';

injectMetaPixels('612158373053571');
injectTikTokPixels('D2V8TUBC77UDSKFRF5V0');
injectGoogle('G-9RQCYSDSDF');
ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();
// serviceWorker.unregister();
